import { useContext, useRef, useEffect } from "react";
import { getUserToken } from "../../services/userService";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { LoaderContext } from "../../context/LoaderContext";
import Login from "../../pages/login/loginPage";
import { AlertContext } from "../../context/AlertContext";
import { Alert, Log } from "../../utils/genericUtils";

function OAuthLoginEndComponent() {
  const urlParams = new URLSearchParams(window.location.search);
  const authorizationCode = urlParams.get("code");

  const router = useNavigate();

  const { show, showloader, hideloader } = useContext(LoaderContext);
  const { globalAlert } = useContext(AlertContext);

  let apiCalled = useRef(false);

  const { user, loginUser } = useContext(UserContext);

  useEffect(() => {
    if (!apiCalled.current) {
      apiCalled.current = true;
      showloader();
      getUserToken(authorizationCode)
        .then((data) => {
          hideloader();
          Log('data: ', data)

          if (data.user) loginUser(data.user);

          //handle MFA
          if (data.mfa_flow) {
            router(`/mfa-login?remember=true`);
            return;
          }

          if (data.jwt) {
            //default to localstorage for OAuth flow
            localStorage.setItem("jwt", data.jwt);
          }

          //thanks for signing up
          if (data.isNew) router(`/registration-success?id=${data.user.username}&isOAuth=true`);
          //dashboard
          else router("/dashboard");
        })
        .catch(() => {
          hideloader();
          Alert(globalAlert, "error", "Something Went Wrong", `We couldn't sign you in, please try again. You might need to wait a few minutes.`);
        });
    }
  }, []);

  //show login page to appear as if the user never left this page
  return <Login />;
}

export default OAuthLoginEndComponent;
